module.exports = __webpack_public_path__ + "static/media/interlaken.4d795471.jpeg";